"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
require("core-js/modules/es6.array.slice.js");
require("core-js/modules/es6.string.link.js");
require("core-js/modules/es6.string.includes.js");
require("core-js/modules/es7.array.includes.js");
require("core-js/modules/es6.array.filter.js");
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));
var _values2 = _interopRequireDefault(require("lodash/values"));
var _pick2 = _interopRequireDefault(require("lodash/pick"));
var _impression = require("@nerdwallet/analytics/react/impression");
var _apollo = require("@nerdwallet/apollo");
var _classes = _interopRequireDefault(require("@nerdwallet/base-styles/classes"));
var _constants = require("@nerdwallet/marketplace/constants");
var _trkHelper = require("@nerdwallet/nw-client-lib/trk-helper");
var _reactApplyNow = _interopRequireWildcard(require("@nerdwallet/react-apply-now"));
var _reactButtonShort = _interopRequireDefault(require("@nerdwallet/react-button-short"));
var _ExternalLink = _interopRequireDefault(require("@nerdwallet/react-icon/nerdwallet-ui/ExternalLink"));
var _Link = require("@nerdwallet/currency/components/Link");
var _reactMarketplaceReviewLink = require("@nerdwallet/react-marketplace-review-link");
var _Body = require("@nerdwallet/currency/components/Body");
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireWildcard(require("react"));
var _analytics = require("./analytics");
var _constants2 = require("./constants");
var _constants3 = require("./analytics/constants");
var _baseMarketplaceCtaModule = _interopRequireDefault(require("./base-marketplace-cta.module.css"));
var _templateObject;
var getApplyNowAnnotationText = function getApplyNowAnnotationText(subtext, federallyInsuredAnnotation, hideInstitutionFromAnnotation, phoneNumber) {
  var annotationText = [];
  if (!hideInstitutionFromAnnotation) {
    annotationText.push(subtext);
  }
  if (federallyInsuredAnnotation) {
    annotationText.push(federallyInsuredAnnotation);
  }

  // TODO: once we remove the phone number subtext from query0, we can remove the extra check here
  if (phoneNumber && subtext.slice(subtext.length - _constants2.PHONE_NUMBER_SUBTEXT.length) !== _constants2.PHONE_NUMBER_SUBTEXT) {
    annotationText.push(_constants2.PHONE_NUMBER_SUBTEXT);
  }
  return annotationText.join(', ');
};
var BaseMarketplaceCta = function BaseMarketplaceCta(_ref) {
  var _link;
  var analyticsPayloadOverrides = _ref.analyticsPayloadOverrides,
    children = _ref.children,
    className = _ref.className,
    cta = _ref.cta,
    disableAnnotation = _ref.disableAnnotation,
    externalClickId = _ref.externalClickId,
    gqlMarketplaceEntity = _ref.gqlMarketplaceEntity,
    hideInstitutionFromAnnotation = _ref.hideInstitutionFromAnnotation,
    hideFederallyInsuredAnnotation = _ref.hideFederallyInsuredAnnotation,
    id = _ref.id,
    linkType = _ref.linkType,
    _onClick = _ref.onClick,
    reviewLinkOverride = _ref.reviewLinkOverride,
    shortButton = _ref.shortButton,
    _ref$showIcon = _ref.showIcon,
    showIcon = _ref$showIcon === void 0 ? !shortButton : _ref$showIcon,
    urlSearchParams = _ref.urlSearchParams,
    legacyTrkProps = _ref.legacyTrkProps,
    logImpression = _ref.logImpression,
    useSecondaryStyleForReviews = _ref.useSecondaryStyleForReviews,
    slug = _ref.slug,
    trackNonMonetizingSegmentShoppingFinished = _ref.trackNonMonetizingSegmentShoppingFinished;
  var _ref2 = cta || gqlMarketplaceEntity.cta,
    ctaLink = _ref2.link,
    ctaSubtext = _ref2.subtext,
    ctaText = _ref2.text,
    ctaType = _ref2.type,
    ctaSecondary = _ref2.secondary,
    ctaClassName = _ref2.className;
  var federallyInsuredAnnotation = gqlMarketplaceEntity.federallyInsuredAnnotation,
    phoneNumber = gqlMarketplaceEntity.phoneNumber;
  var impressionContext = (0, _react.useContext)(_impression.ImpressionContext);
  var shouldIgnoreTrk = (0, _reactApplyNow.useIgnoreTrkContext)();
  var impressionId = impressionContext === null || impressionContext === void 0 ? void 0 : impressionContext.impressionId;
  var shoppingFinishedPayloadOverrides = (0, _objectSpread2.default)({
    product_impression_id: impressionId,
    cta_type: _constants3.LEGACY_LINK_TYPE_MAP[linkType],
    // TODO (RUR-246): pass `linkType` directly once apply-now link types have been updated
    destination_url: ctaLink
  }, (0, _pick2.default)(analyticsPayloadOverrides, _constants3.SHOPPING_FINISHED_OVERWRITABLE_FIELDS));
  var link = ctaLink;
  if (urlSearchParams) {
    var url = new URL(link);
    urlSearchParams.forEach(function (_ref3) {
      var key = _ref3.key,
        value = _ref3.value;
      url.searchParams.set(key, value);
    });
    link = url.href;
  }
  if (!shouldIgnoreTrk && link) {
    var _params;
    link = (0, _trkHelper.setTrk)({
      url: link,
      taxonomy: legacyTrkProps === null || legacyTrkProps === void 0 ? void 0 : legacyTrkProps.trkTaxonomy,
      params: (_params = {}, (0, _defineProperty2.default)(_params, _trkHelper.TrkTag.location, 'MarketplaceApplyNow'), (0, _defineProperty2.default)(_params, _trkHelper.TrkTag.element, legacyTrkProps !== null && legacyTrkProps !== void 0 && legacyTrkProps.trkElement || linkType === _reactApplyNow.LinkType.applyNowButton ? _trkHelper.TrkElement.button : _trkHelper.TrkElement.hyperlink), (0, _defineProperty2.default)(_params, _trkHelper.TrkTag.pageType, legacyTrkProps === null || legacyTrkProps === void 0 ? void 0 : legacyTrkProps.trkPageType), (0, _defineProperty2.default)(_params, _trkHelper.TrkTag.sectionCategory, legacyTrkProps === null || legacyTrkProps === void 0 ? void 0 : legacyTrkProps.trkSectionCategory), _params)
    });
  }
  if ((_link = link) !== null && _link !== void 0 && _link.includes('analyze.nerdwallet.com/personal-loan/apply/personal-loan-purpose')) {
    link = "".concat(link, "&affiliateName=NerdWallet&affiliateId=1333&subId1=organic&subId2=pl_roundups").concat(slug ? "&subId3=".concat(slug) : '');
  }
  switch (ctaType) {
    case _constants2.CTA_TYPES.APPLY_NOW:
      {
        var _analyticsPayloadOver, _gqlMarketplaceEntity, _gqlMarketplaceEntity2, _gqlMarketplaceEntity3, _gqlMarketplaceEntity4, _gqlMarketplaceEntity5, _gqlMarketplaceEntity6;
        var analyticsProps = {
          /**
           * TODO (RUR-246): The following props are used in ApplyNow to build out the click event.
           * Determine if these are still needed once we cutover to Bedrock.
           * https://github.com/NerdWallet/react-components/blob/master/components/apply-now/src/apply-now-link.jsx#L152
           */
          id: id,
          impressionId: impressionId,
          linkType: (_analyticsPayloadOver = analyticsPayloadOverrides === null || analyticsPayloadOverrides === void 0 ? void 0 : analyticsPayloadOverrides.cta_type) !== null && _analyticsPayloadOver !== void 0 ? _analyticsPayloadOver : linkType,
          finishType: analyticsPayloadOverrides === null || analyticsPayloadOverrides === void 0 ? void 0 : analyticsPayloadOverrides.finish_type,
          pageNumber: analyticsPayloadOverrides === null || analyticsPayloadOverrides === void 0 ? void 0 : analyticsPayloadOverrides.page_number,
          productPosition: analyticsPayloadOverrides === null || analyticsPayloadOverrides === void 0 ? void 0 : analyticsPayloadOverrides.element_position,
          sectionPosition: analyticsPayloadOverrides === null || analyticsPayloadOverrides === void 0 ? void 0 : analyticsPayloadOverrides.section_position,
          productImpressionId: analyticsPayloadOverrides === null || analyticsPayloadOverrides === void 0 ? void 0 : analyticsPayloadOverrides.product_impression_id,
          monetizable: gqlMarketplaceEntity.monetizable,
          productDisplayDriver: (analyticsPayloadOverrides === null || analyticsPayloadOverrides === void 0 ? void 0 : analyticsPayloadOverrides.driver) || _constants3.PRODUCT_DISPLAY_DRIVER,
          sectionName: analyticsPayloadOverrides === null || analyticsPayloadOverrides === void 0 ? void 0 : analyticsPayloadOverrides.section_name,
          prequalId: analyticsPayloadOverrides === null || analyticsPayloadOverrides === void 0 ? void 0 : analyticsPayloadOverrides.prequal_id,
          /**
           * TODO (RUR-246): The following props are used in ApplyNow to build out the legacy
           * Impression event and/or Click events that don't log an impression.
           * https://github.com/NerdWallet/react-components/blob/master/components/apply-now/src/apply-now-link.jsx#L151
           * https://github.com/NerdWallet/react-components/blob/master/components/apply-now/src/apply-now-link.jsx#L86-L101
           * These should be safe to remove once we cutover to Bedrock.
           */
          isCC: gqlMarketplaceEntity.productType === _constants.PRODUCT_TYPES.CREDIT_CARDS,
          issuer: (_gqlMarketplaceEntity = gqlMarketplaceEntity.analyticsProps) === null || _gqlMarketplaceEntity === void 0 ? void 0 : _gqlMarketplaceEntity.legacyIssuer,
          productLocation: 'MarketplaceApplyNow',
          offerVersionId: gqlMarketplaceEntity.versionId,
          productId: (_gqlMarketplaceEntity2 = gqlMarketplaceEntity.analyticsProps) === null || _gqlMarketplaceEntity2 === void 0 ? void 0 : _gqlMarketplaceEntity2.productId,
          productSlug: (_gqlMarketplaceEntity3 = gqlMarketplaceEntity.analyticsProps) === null || _gqlMarketplaceEntity3 === void 0 ? void 0 : _gqlMarketplaceEntity3.legacySlug,
          logImpression: logImpression && ((_gqlMarketplaceEntity4 = gqlMarketplaceEntity.analyticsProps) === null || _gqlMarketplaceEntity4 === void 0 ? void 0 : _gqlMarketplaceEntity4.hasLegacyImpression),
          vertical: (_gqlMarketplaceEntity5 = gqlMarketplaceEntity.analyticsProps) === null || _gqlMarketplaceEntity5 === void 0 ? void 0 : _gqlMarketplaceEntity5.legacyVertical,
          additionalEventData: (_gqlMarketplaceEntity6 = gqlMarketplaceEntity.analyticsProps) === null || _gqlMarketplaceEntity6 === void 0 ? void 0 : _gqlMarketplaceEntity6.legacyAdditionalEventData
        };
        if (linkType !== _reactApplyNow.LinkType.applyNowButton) {
          return /*#__PURE__*/_react.default.createElement(_reactApplyNow.ApplyNowLink, (0, _extends2.default)({
            className: className,
            link: link,
            onClick: _onClick
          }, analyticsProps), children || ctaText);
        }
        return /*#__PURE__*/_react.default.createElement(_reactApplyNow.default, (0, _extends2.default)({
          annotationText: getApplyNowAnnotationText(ctaSubtext, hideFederallyInsuredAnnotation ? null : federallyInsuredAnnotation, hideInstitutionFromAnnotation, phoneNumber),
          className: className,
          disableAnnotation: disableAnnotation,
          icon: /*#__PURE__*/_react.default.createElement(_ExternalLink.default, {
            className: _baseMarketplaceCtaModule.default.icon,
            size: "small"
          }),
          link: link,
          ext_click_id: externalClickId,
          onClick: _onClick,
          pay_per_call: phoneNumber,
          primary: !ctaSecondary,
          secondary: !!ctaSecondary,
          showIcon: showIcon,
          shortButton: shortButton,
          text: ctaText,
          textClassName: ctaClassName
        }, analyticsProps));
      }
    case _constants2.CTA_TYPES.READ_REVIEW:
      {
        var type = linkType === _reactApplyNow.LinkType.applyNowButton ? _reactMarketplaceReviewLink.LINK_TYPES.BUTTON : _reactMarketplaceReviewLink.LINK_TYPES.LINK;
        return /*#__PURE__*/_react.default.createElement(_reactMarketplaceReviewLink.GraphQlMarketplaceReviewLink, {
          className: className,
          href: reviewLinkOverride || link,
          onClick: function onClick() {
            (0, _analytics.trackNonMonetizingShoppingFinished)(gqlMarketplaceEntity, shoppingFinishedPayloadOverrides);
            if (trackNonMonetizingSegmentShoppingFinished) trackNonMonetizingSegmentShoppingFinished(linkType);
            _onClick();
          }
          // TODO (REVS-112): Either remove or replace wiht a more permanent solution
          ,
          primary: !useSecondaryStyleForReviews && !ctaSecondary,
          shortButton: shortButton,
          shouldIgnoreTrk: shouldIgnoreTrk,
          subtext: ctaSubtext,
          text: ctaText,
          type: type
          // TODO (RUR-246): The following props can be removed once we cutover to Bedrock
          ,
          trkTaxonomy: legacyTrkProps === null || legacyTrkProps === void 0 ? void 0 : legacyTrkProps.trkTaxonomy,
          trkSectionCategory: legacyTrkProps === null || legacyTrkProps === void 0 ? void 0 : legacyTrkProps.trkSectionCategory,
          trkPageType: legacyTrkProps === null || legacyTrkProps === void 0 ? void 0 : legacyTrkProps.trkPageType,
          trkLocation: [legacyTrkProps === null || legacyTrkProps === void 0 ? void 0 : legacyTrkProps.trkLocation, 'MarketplaceApplyNow', 'MarketplaceReviewLink'].filter(Boolean).join('-')
        }, children);
      }
    default:
      {
        if (linkType !== _reactApplyNow.LinkType.applyNowButton) {
          return /*#__PURE__*/_react.default.createElement(_Link.Link, {
            className: className,
            href: link,
            onClick: function onClick() {
              (0, _analytics.trackNonMonetizingShoppingFinished)(gqlMarketplaceEntity, shoppingFinishedPayloadOverrides);
              if (trackNonMonetizingSegmentShoppingFinished) trackNonMonetizingSegmentShoppingFinished(linkType);
              _onClick();
            }
          }, children || ctaText);
        }
        var buttonClassName = (0, _classnames.default)([(0, _classes.default)('width-100'), (0, _classes.default)('text-align-center')]);
        var annotationClassName = (0, _classnames.default)([(0, _classes.default)(['margin-top-1', 'text-align-center'])]);
        var CtaComponent = /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactButtonShort.default, {
          className: buttonClassName,
          href: link,
          onClick: function onClick() {
            (0, _analytics.trackNonMonetizingShoppingFinished)(gqlMarketplaceEntity, shoppingFinishedPayloadOverrides);
            if (trackNonMonetizingSegmentShoppingFinished) trackNonMonetizingSegmentShoppingFinished(linkType);
            _onClick();
          },
          primary: !ctaSecondary,
          short: shortButton
        }, ctaText), !!ctaSubtext ? /*#__PURE__*/_react.default.createElement(_Body.Body, {
          className: annotationClassName,
          light: true,
          size: "small"
        }, ctaSubtext) : null);
        if (className) {
          return /*#__PURE__*/_react.default.createElement("div", {
            className: className
          }, CtaComponent);
        }
        return CtaComponent;
      }
  }
};
if (process.env.NODE_ENV !== 'production') {
  var PropTypes = require('prop-types'); // eslint-disable-line global-require
  BaseMarketplaceCta.propTypes = {
    analyticsPayloadOverrides: PropTypes.shape({
      bot_suspected: PropTypes.bool,
      driver: PropTypes.string,
      element_position: PropTypes.number,
      cta_type: PropTypes.string,
      finish_type: PropTypes.string,
      model_execution_ids: PropTypes.arrayOf(PropTypes.string),
      page_number: PropTypes.number,
      parent_impression_id: PropTypes.string,
      prequal_id: PropTypes.string,
      section_name: PropTypes.string,
      section_position: PropTypes.number,
      product_impression_id: PropTypes.string
    }),
    children: PropTypes.node,
    className: PropTypes.string,
    cta: PropTypes.shape({
      link: PropTypes.string.isRequired,
      subtext: PropTypes.string,
      text: PropTypes.string.isRequired,
      type: PropTypes.string.isRequired,
      secondary: PropTypes.boolean,
      className: PropTypes.string
    }),
    disableAnnotation: PropTypes.bool,
    gqlMarketplaceEntity: PropTypes.shape({
      analyticsProps: PropTypes.shape({
        hasLegacyImpression: PropTypes.bool,
        legacyAdditionalEventData: PropTypes.object,
        // eslint-disable-line react/forbid-prop-types
        legacyIssuer: PropTypes.string,
        legacySlug: PropTypes.string,
        legacyVertical: PropTypes.string,
        productId: PropTypes.string
      }),
      cta: PropTypes.shape({
        link: PropTypes.string.isRequired,
        subtext: PropTypes.string,
        text: PropTypes.string.isRequired,
        type: PropTypes.string.isRequired
      }),
      monetizable: PropTypes.string.isRequired,
      productType: PropTypes.string.isRequired,
      versionId: PropTypes.number.isRequired
    }).isRequired,
    hideInstitutionFromAnnotation: PropTypes.bool,
    hideFederallyInsuredAnnotation: PropTypes.bool,
    id: PropTypes.string.isRequired,
    linkType: PropTypes.oneOf((0, _values2.default)(_reactApplyNow.LinkType)),
    onClick: PropTypes.func,
    reviewLinkOverride: PropTypes.string,
    shortButton: PropTypes.bool,
    showIcon: PropTypes.bool,
    urlSearchParams: PropTypes.arrayOf(PropTypes.shape({
      key: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired
    })),
    // TODO (RUR-246): The following props can be removed once we cutover to Bedrock
    legacyTrkProps: PropTypes.shape({
      trkElement: PropTypes.string,
      trkLocation: PropTypes.string,
      trkPageType: PropTypes.string,
      trkSectionCategory: PropTypes.string,
      trkTaxonomy: PropTypes.shape({
        contentType: PropTypes.string,
        pageType: PropTypes.string,
        topic: PropTypes.string,
        vertical: PropTypes.string
      })
    }),
    logImpression: PropTypes.bool,
    // TODO (REVS-112): Either remove or replace wiht a more permanent solution
    useSecondaryStyleForReviews: PropTypes.bool,
    slug: PropTypes.string,
    trackNonMonetizingSegmentShoppingFinished: PropTypes.func
  };
}
BaseMarketplaceCta.defaultProps = {
  linkType: _reactApplyNow.LinkType.applyNowButton,
  logImpression: true,
  onClick: function onClick() {},
  // TODO (REVS-112): Either remove or replace wiht a more permanent solution
  useSecondaryStyleForReviews: false
};
BaseMarketplaceCta.fragment = (0, _apollo.gql)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  fragment BaseMarketplaceCta on MarketplaceEntityInterface {\n    productType\n    versionId\n\n    ... on BankingOfferV2 {\n      federallyInsuredAnnotation\n    }\n\n    ... on CreditCardsOfferV2 {\n      phoneNumber\n    }\n\n    ... on MarketplaceEntityWithPlacementInterface {\n      analyticsProps {\n        hasLegacyImpression\n        legacyAdditionalEventData\n        legacyIssuer\n        legacySlug\n        legacyVertical\n        productId\n      }\n      cta {\n        ...BaseMarketplaceCtaOnEntityPlacementCTA\n      }\n      monetizable\n    }\n\n    ...MarketplaceReviewLink\n    ...trackNonMonetizingShoppingFinished\n  }\n\n  fragment BaseMarketplaceCtaOnEntityPlacementCTA on EntityPlacementCTA {\n    link\n    subtext\n    text\n    type\n  }\n\n  ", "\n  ", "\n"])), _reactMarketplaceReviewLink.GraphQlMarketplaceReviewLink.fragment, _analytics.trackNonMonetizingShoppingFinished.fragment);
var _default = BaseMarketplaceCta;
exports.default = _default;